import http from '@/support/plugin/axios'

export const 

getCompanyLoyaltyByCompanyId = (companyId) =>  http.get(`companies/${companyId}/loyalty`)